// removed by extract-text-webpack-plugin
module.exports = {"container":"styles_container__1C0Ll"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ImageEditor/styles.module.css
// module id = 94
// module chunks = 0